"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const uuid_1 = require("uuid");
const HBIcon_1 = __importDefault(require("../components/HBIcon/HBIcon"));
function Screwdriver16Svg(props) {
    const id0 = (0, react_1.useMemo)(() => (0, uuid_1.v4)(), []);
    return react_1.default.createElement("svg", Object.assign({ width: "16px", height: "16px", viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink" }, props),
        react_1.default.createElement("desc", null, "Created with Sketch."),
        react_1.default.createElement("defs", null,
            react_1.default.createElement("path", { d: "M20.8565106,13.4931717 C18.6847737,15.6649086 15.4876919,16.186378 12.823551,15.0575798 L4.88113087,23 L1,19.1188691 L8.94242015,11.176449 C7.81362197,8.51230809 8.33509135,5.31522633 10.5068283,3.14348939 C12.6785652,0.971752447 15.875647,0.450283067 18.5397879,1.57908125 C18.9349789,1.74652392 19.6305832,2.17429872 19.6305832,2.17429872 L16.5759856,5.5827605 L16.9061858,6.94115894 L18.3967253,7.38934009 L21.8903167,4.5603606 L22.4209187,5.46021212 C23.5497169,8.12435301 23.0282476,11.3214348 20.8565106,13.4931717 Z M4.88113087,20.1715729 L12.3625616,12.6901421 L13.6038051,13.2160578 C15.5833002,14.0547711 17.8960576,13.6251976 19.442297,12.0789581 C20.5774773,10.9437779 21.1107921,9.3954564 20.9822452,7.86917496 L18.8335203,9.60913199 L15.2333393,8.52661574 L14.3838832,5.03206969 L16.184755,3.02257334 C14.6410801,2.87672626 13.0695948,3.40914999 11.9210419,4.55770295 C10.3748024,6.10394238 9.94522889,8.41669976 10.7839422,10.3961949 L11.3098579,11.6374384 L3.82842712,19.1188691 L4.88113087,20.1715729 Z", id: `screwdriver16-${id0}` })),
        react_1.default.createElement("g", { id: "screwdriver-16", stroke: "none", strokeWidth: 1, fill: "none", fillRule: "evenodd" },
            react_1.default.createElement("mask", { id: "mask-2", fill: "white" },
                react_1.default.createElement("use", { xlinkHref: `#screwdriver16-${id0}` })),
            react_1.default.createElement("use", { id: "Mask", fill: "#000000", fillRule: "nonzero", xlinkHref: `#screwdriver16-${id0}` })));
}
function Screwdriver16(_a) {
    var { svgProps } = _a, props = __rest(_a, ["svgProps"]);
    return react_1.default.createElement(HBIcon_1.default, Object.assign({}, props),
        react_1.default.createElement(Screwdriver16Svg, Object.assign({}, svgProps)));
}
exports.default = Screwdriver16;
//# sourceMappingURL=Screwdriver16.js.map